var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site_box flex2"},[_c('div',{staticClass:"site_nav flex3"},[_vm._v("\n\t\t当前位置：\n\t\t"),_c('span',{on:{"click":_vm.goHome}},[_vm._v("首页")]),_vm._v(">\n\t\t"),_c('span',[_vm._v(_vm._s(_vm.lone))]),_vm._v(">\n\t\t"),_c('span',[_vm._v(_vm._s(_vm.ltwo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }